import { makeStyles } from '@mui/styles';

type StylesProps = {
  direction: 'vertical' | 'horizontal',
  padding: string,
  mapHeight: string,
  mapWidth: string,
  squareMap?: boolean
}

export const useStyles = makeStyles((theme:any) => ({
  root: { padding: (props) => theme.spacing(Number(props.padding)), width: '100%', margin: 0, },
  mapContainer: {
    width: (props: StylesProps) => (props.direction === 'vertical' ? '100%' : props.mapWidth),
    height: (props: StylesProps) => (props.squareMap ? 'auto' : props.mapHeight),
    minHeight: (props: StylesProps) => (props.squareMap ? 0 : props.mapHeight),
    aspectRatio: (props: StylesProps) => (props.squareMap ? '1 / 1' : undefined),
    // In the row layout a stretched flex item ignores aspect-ratio, so a taller sibling panel
    // would stretch the square map to its own height. Pin it to the top to stay square.
    alignSelf: (props: StylesProps) => (props.squareMap && props.direction === 'horizontal' ? 'flex-start' : undefined)
  },
  // Opt-in (ctaMapControls) circular orange OpenLayers controls (secondary = CTA orange, same as ContainedButton).
  // Scoped via the className passed to OlMap so other OlMap consumers keep the default look.
  mapControls: {
    '& .ol-zoom-button-container, & .ol-full-screen-button': {
      backgroundColor: 'transparent',
      padding: 0,
      margin: 0,
      borderRadius: 0,
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(1),
      bottom: theme.spacing(1),
      top: 'auto',
      '& button': {
        width: 44,
        height: 44,
        minWidth: 44,
        margin: 0,
        padding: 0,
        borderRadius: '50%',
        border: 'none',
        cursor: 'pointer',
        fontSize: theme.typography.h5.fontSize,
        fontWeight: theme.typography.fontWeightBold,
        lineHeight: 1,
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.common.black,
        boxShadow: theme.shadows[2],
        transition: theme.transitions.create(['background-color', 'box-shadow'], { duration: theme.transitions.duration.shortest }),
        [theme.breakpoints.down('md')]: { width: 48, height: 48, minWidth: 48 },
        '@media (hover: none) and (pointer: coarse)': { width: 48, height: 48, minWidth: 48 },
        '&:hover': { backgroundColor: theme.palette.secondary.dark, boxShadow: theme.shadows[4] },
        '&:active': { backgroundColor: theme.palette.secondary.dark, boxShadow: theme.shadows[1] },
        '&:focus, &:focus-visible': {
          outline: `2px solid ${theme.palette.primary.main}`,
          outlineOffset: 2,
          backgroundColor: theme.palette.secondary.main
        },
        '&:focus:hover': { backgroundColor: theme.palette.secondary.dark }
      }
    },
    '& .ol-zoom-button-container': { left: theme.spacing(1), right: 'auto' },
    '& .ol-full-screen-button': { right: theme.spacing(1), left: 'auto' }
  },
  controls: {
    backgroundColor: theme.palette.common.white,
    flex: 1,
    padding: theme.spacing(1.5),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    width: '100%'
  }
}));
